'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkPartnerLogos.module.css';

export function DevlinkPartnerLogos({ as: _Component = _Builtin.Section }) {
  return (
    <_Component
      className={_utils.cx(_styles, 'home-partner-section')}
      grid={{
        type: 'section',
      }}
      tag="div"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'container')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'align-center')} tag="div">
          <_Builtin.Heading className={_utils.cx(_styles, 'txt-header')} tag="h5">
            {'The official installation '}
            <_Builtin.Span className={_utils.cx(_styles, 'no-wrap')}>{'partner of'}</_Builtin.Span>
          </_Builtin.Heading>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'medium-1')} tag="div" />
        <_Builtin.Block className={_utils.cx(_styles, 'home-partner-listing')} tag="div">
          <_Builtin.Image
            className={_utils.cx(_styles, 'home-partner-logo')}
            loading="lazy"
            width="auto"
            height="auto"
            alt="Walmart company logo"
            src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/611d359b8cf5b38df95d4885_walmart.png"
          />
          <_Builtin.Image
            className={_utils.cx(_styles, 'home-partner-logo')}
            loading="lazy"
            width="auto"
            height="auto"
            alt="Target company logo"
            src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/611d3593177ee65e374f72bf_target.png"
          />
          <_Builtin.Image
            className={_utils.cx(_styles, 'home-partner-logo')}
            loading="lazy"
            width="auto"
            height="auto"
            alt="Xfinity company logo"
            src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/611d359b3693d2591428037d_xfinity.png"
          />
          <_Builtin.Image
            className={_utils.cx(_styles, 'home-partner-logo')}
            loading="lazy"
            width="auto"
            height="auto"
            alt="Logitech company logo"
            src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/611d359b61e1cbb3d3bfc4a3_logitech.png"
          />
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
